import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import { BoosterId, boosterMap } from '../defs/booster';
import { isMatch2UnlockableUnlocked } from 'src/replicant/match2/match2.getters';
import StateObserver from 'src/StateObserver';
import { createEmitter } from 'src/lib/Emitter';
import { matchTheme } from 'src/game/theme/match2/Match2Theme';
import { Match2BoosterButtonNew } from './Match2BoosterButtonNew';

type Match2BoostersBarOpts = Omit<
  ImageScaleViewOpts,
  'image' | 'width' | 'height'
>;

export class Match2BoostersBarNew extends ImageScaleView {
  private items: Match2BoosterButtonNew[] = [];

  constructor(opts: Match2BoostersBarOpts = {}) {
    super({
      image: matchTheme().getUIAsset('boosters_bg.png'),
      width: 648,
      height: 130,
      offsetY: -40,
      ...opts,
    });

    const boosterIds = Object.keys(boosterMap).slice(0, 4) as BoosterId[];

    const { startX, startY } = { startX: 25, startY: -10 };
    for (let index = 0; index < boosterIds.length; index++) {
      const item = new Match2BoosterButtonNew();
      item.onPurchaseComplete = () => this.refreshButtons();
      item.setBooster(boosterIds[index]);
      item.updateOpts({ x: 125 * index + startX, y: startY });
      this.addSubview(item);
      this.items.push(item);
    }

    createEmitter(this, ({ user }) => {
      return user.match2.boosters;
    }).addListener(() => {
      this.refreshButtons();
    });
  }

  public setInteractive(v: boolean) {
    this.items.forEach((item) => item.setInteractive(v));
  }

  public refresh() {
    this.items.forEach((item) => {
      item.setLocked(
        !isMatch2UnlockableUnlocked(
          StateObserver.getState().user,
          item.boosterId,
        ),
      );
      item.autoUpdate();
    });
  }

  public getButtonById(id: BoosterId) {
    return this.items.find((item) => item.boosterId === id);
  }

  private refreshButtons() {
    this.items.forEach((item) => item.refresh());
  }

  public stopAutoUpdate() {
    this.items.forEach((item) => item.stopAutoUpdate());
  }
}
